/**
 * ***********************
 * Email Templates Routes Components *
 * ***********************
 */
const EmailTemplate = () => import('@/components/SysSettings/EmailTemplate');

export default {
  title: 'Email Templates',
  link: '/configuration/email-templates',
  path: 'email-templates',
  component: EmailTemplate,
  permission: [
    {
      action: 'view',
      entity: 'email_templates'
    }
  ],
  meta: {
    permission: [
      {
        action: 'view',
        entity: 'email_templates'
      }
    ],
    id: 'configuration__email-templates-tab'
  }
};
